<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :style="{ height: '100%',width:'100%' }"
      :close-on-click-overlay="false"
      class="tkNeed linear-main3"
      :close-on-popstate="true"
    >
      <ld-header
        @click-left="toggle"
        :transparent="true"
        :white="true"
      >
        {{ $t('A106','需求单') }}
      </ld-header>
      <div class="tkNeedwrapper full-width">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div
            v-for="(info,index) in voyage"
            :key="index"
            class="voyage bg-white"
          >
            <van-row
              class="city"
              type="flex"
              align="center"
            >
              <van-col
                span="10"
                :class="[ info.depport.cityName ? '' : 'disable' ]"
                @click="openComponents('city',index,'depport')"
              >
                <van-tag
                  class="tag-left"
                  mark
                  type="warning"
                >
                  {{ index +1 }} 程
                </van-tag>
                {{ info.depport.cityName || $t('C104','出发城市') }}
              </van-col>
              <van-col
                span="4"
                class="city-icon"
                @click="reforeCity(index)"
              >
                <ld-icon
                  class="main-color"
                  size="28"
                  type="iconzhuanhuan"
                />
              </van-col>
              <van-col
                :class="[ info.arrport.cityName ? '' : 'disable' ]"
                span="10"
                class="dest-city"
                @click="openComponents('city',index,'arrport')"
              >
                {{ info.arrport.cityName || $t('C105','到达城市') }}
              </van-col>
            </van-row>
            <van-icon
              name="close"
              class="tag-right main-color"
              @click="sliceVoyage(index)"
            />

            <van-row
              type="flex"
              align="center"
              class="date"
            >
              <van-col
                span="12"
                class="depart-date"
                :class="[ info.departDate.date ? '' : 'disable' ]"
                @click="openComponents('date',index,'departDate')"
              >
                {{ (info.departDate.date) || $t('C106','出发日期') }}
              </van-col>
              <van-col
                span="12"
                @click="openComponents('date',index,'arriveDate')"
                class="dest-date"
                :class="[ info.arriveDate.date ? '' : 'disable' ]"
              >
                {{ (info.arriveDate.date) || $t('C107','返程日期') }}
              </van-col>
            </van-row>
          </div>

          <!--  -->
          <div>
            <van-cell
              :border="false"
              @click="addVoyage"
            >
              <template slot="title">
                <van-icon
                  size="18px"
                  name="add-o"
                  class="vertical-middle main-color"
                />
                <span class="main-color"> {{ $t('C502','再加一程') }}</span> 
              </template>
            </van-cell>

            <!--  -->
            <van-cell-group>
              <van-field
                :readonly="true"
                :border="false"
                placeholder="乘机人数量"
                is-link 
                @click="showPicker(2)"
              >
                <template slot="input">
                  {{ adultNum }} {{ $t('C115','成人') }} {{ childNum }} {{ $t('C116','儿童') }} {{ babyNum }} {{ $t('C117','婴儿') }} 
                </template>
              </van-field>
              <van-field
                :readonly="true"
                :border="false"
                :placeholder="$t('C114','乘客类型')"
                is-link 
                @click="showPicker(0)"
                v-model="psgTypeName"
              />
              <van-field
                :readonly="true"
                :border="false"
                :placeholder="$t('C108','不限舱位')"
                is-link 
                @click="showPicker(1)"
                v-model="cabinName"
              />
              <van-field
                placeholder="输入期望价格"
                maxlength="8"
                v-model="expectBudget"
                clearable
                onkeyup="value=this.value.replace(/\D+/g,'')"
              />
              <div class="font12">
                <van-field
                  clearable
                  type="textarea"
                  maxlength="80"
                  v-model="content"
                  placeholder="输入您的特殊需求，例如：指定航空公司、指定航班、出发时间、直飞或转机、价位需求等"
                />
              </div>
            </van-cell-group>

            <!-- 联系信息 -->

            <van-field
              :label="$t('D022','联系信息')"
              :readonly="true"
              @click="openComponents('linker')"
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})
                
                <div class="font12 gray">
                  {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>
    
          <!--  -->
          <div class="pad-16">
            <ld-button
              main
              size="lg"
              @click="bookOrder"
            >
              {{ $t('B004','提交') }}
            </ld-button>
          </div>
        </mescroll-vue>


        <!-- 编辑联系人 -->
        <ld-edit-linker
          ref="linker"
          :data="linker"
          @selected="getLinker"
        />

        <!-- 选择器 -->
        <van-popup
          v-model="showPopupPicker"
          position="bottom"
          :close-on-popstate="true"
        >
          <van-picker
            show-toolbar
            :columns="pickerData"
            @confirm="getPickerData"
            @cancel="showPopupPicker=false"
          >
            <template
              v-slot:columns-top
              v-if="pickerIndex==2"
            >
              <van-row class="text-center font12">
                <van-col span="8">
                  {{ $t('C115','成人') }}
                </van-col>
                <van-col span="8">
                  {{ $t('C116','儿童') }}(2-12岁)
                </van-col>
                <van-col span="8">
                  {{ $t('C117','婴儿') }}(小于2岁)
                </van-col>
              </van-row>
            </template>
          </van-picker>
        </van-popup>

        <!-- 城市 -->
        <city
          ref="city"
          @selected="voyageChange"
          :city-type="0"
          :tab-index="1"
        />

        <!-- 日历 -->
        <!-- <ld-date 
          ref="date"
          @selected="voyageChange"
          :mode="2"
        /> -->
        <Ld-calendar
          ref="date"
          type="single"
          @selected="getDate"
        />
        <!--  -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Field,Cell,CellGroup,Popup,Picker ,Icon,Tag} from 'vant'
import ldButton from 'Common/ldButton'
import { mapGetters } from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
import City from 'Common/city'
import { formatDate } from 'Utils/dateUtil'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'TkQuerys',
  data:function(){
    return {
      down:{use:false},
      'psgType':'',//乘机人类型
      psgTypeName:'',
      'expectBudget':'',//期望价格
      'content':'',//备注内容
      'adultNum':1,
      'childNum':0,//
      'babyNum':0,
      'cabin':'',//舱位
      cabinName:'',
      'voyageType':1,//1单程2往返3联程4缺口
      showPopupPicker:false,
      pickerData:[],//选择器数据
      voyage:[],//行程
      voyageIndex:0,//当前选中行程
      way:1, //1 出发城市  2到达城市
      pickerIndex:0,//
      isShow:false,
      linker:{}
    }
  },
  components: {
    [Field.name]:Field,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Icon.name]:Icon,
    [Tag.name]:Tag,
    ldButton,
    ldEditLinker,
    City,
    MescrollVue,
    LdCalendar: () => import('Common/ldCalendar'),
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      userInfo:'userInfo'
    })
  },
  created(){
    this.init()
  },
  methods:{
    init(){
      this.linker= {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }
      this.addVoyage()
    },
    showDate(){
      this.$refs.date.toggle({
        defaultDate:this.voyage[this.voyageIndex][this.way].date
      })
    },
    // 日期回调
    getDate(date){
      this.voyage[this.voyageIndex][this.way].date=date
    },
    voyageChange(info){//选择城市 //选择时间
      this.voyage[this.voyageIndex][this.way]=info
    },
    reforeCity(index){//出发到达城市对调
      [this.voyage[index].depport,this.voyage[index].arrport]=[this.voyage[index].arrport,this.voyage[index].depport]
    },
    addVoyage(){//加行程
      if(this.voyage.length>3){
        return
      }
      this.voyage.push({
        depport:{},
        arrport:{},
        arriveDate:{date:''},
        departDate:{date:''}
      })
    },
    sliceVoyage(index){//减行程
      this.voyage.splice(index,1)
    },
    showPicker(index){//选择器
      let obj=[
        [
          {value:'1',text:'普通成人'},
          {value:'2',text:'劳务'},
          {value:'3',text:'留学生'},
          {value:'4',text:'新移民'}
        ],
        [
          { value: '', text: this.$t('C108','不限舱位') },
          { value: '3', text: '经济舱' },
          { value: '1', text: '公务舱/头等舱' },
        ],
        [
          {values: [1,2,3,4,5,6,7,8,9]},
          {values: ['0',1,2],defaultIndex: 0},
          {values: ['0',1],defaultIndex: 0}
        ]
      ]
      this.pickerData=obj[index]
      this.pickerIndex=index
      this.showPopupPicker=true
    },
    getPickerData(info){//获取 乘机人数量类型 舱位
      if(this.pickerIndex==0){
        this.psgType=info.value
        this.psgTypeName=info.text
      }else if(this.pickerIndex==1){
        this.cabin=info.value
        this.cabinName=info.text
      }else if(this.pickerIndex==2){
        [this.adultNum,this.childNum,this.babyNum]=info
      }
      this.showPopupPicker=false
    },
    //下单
    bookOrder(){
      //非空校验
      if(this.adultNum<1){
        this.$toast('请选择乘机人数！')
        return false
      }
      var str={
        'adultNum':this.adultNum,
        'babyNum':this.babyNum,
        'childNum': this.childNum,
        'cabin': this.cabin,
        'content': this.content,
        'expectBudget': this.expectBudget,
        'linkEmail': this.linker.linkEmail,
        'linkTel': this.linker.linkTel,
        'linkman':this.linker.linkMan,
        'orderFrom':'10506',
        'psgType': this.psgType,
        'tkNeedRanges': [],
        'tripType': this.tripType,
        'voyageType': this.voyageType,
        international:1,
      }
      if(this.voyage.length==1){
        if(this.voyage[0].arriveDate.date){
          str.voyageType=2
        }else{
          str.voyageType=1
        }
      }else if(this.voyage.length>=2){
        str.voyageType=3
      }
      let item=this.voyage
      for(let i=0;i<item.length;i++){
        let cache=item[i]
        if(cache.arriveDate.date&&(cache.departDate.date>cache.arriveDate.date)){
          this.$toast('返程日期不能小于去程日期！')
          return
        }
        let obj={
          'arriveAirport': cache.arrport.threeCode||cache.arrport.arriveAirport,
          'arriveAirportName': cache.arrport.airportName||cache.arrport.jcZdName||cache.arrport.arriveAirportName || cache.arrport.airportBeans.airportName,
          'arriveCity': cache.arrport.cityId||cache.arrport.arriveCity,
          'arriveCityName': cache.arrport.cityName||cache.arrport.arriveCityName,
          'arriveTime': cache.arriveDate.date||cache.arrport.arriveTime,
          'departAirport': cache.depport.threeCode||cache.depport.departAirport,
          'departAirportName': cache.depport.airportName||cache.depport.jcZdName||cache.depport.departAirportName || cache.depport.airportBeans.airportName,
          'departCity': cache.depport.cityId||cache.depport.departCity,
          'departCityName':  cache.depport.cityName||cache.depport.departCityName,
          'departTime': cache.departDate.date||cache.depport.departTime
        }
        if(!obj.departCityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C104','出发城市'))
          return
        }else if(!obj.arriveCityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C105','到达城市'))
          return
        }else if(!obj.departTime){
          this.$toast(this.$t('F049','请选择')+this.$t('C106','出发日期'))
          return
        }
        if(cache.depport.international==0||cache.arrport.international==0){
          str.international=0
        }
        str.tkNeedRanges.push(obj)
      }
            
      if(!str.expectBudget){
        this.$toast('请输入期望价格！')
        return
      }
      if(!str.psgType){
        this.$toast('请选择乘客类型！')
        return
      }
      if(!str.linkTel){
        this.$toast('请输入联系人手机号码！')
        return
      }
      this.$api['tkIntQuery/tkNeedOrderAdd'](str).then((res) =>{
        let cache=res.data||{}
        this.$dialog({message:'您的需求已经提交成功，稍后会有客服人员与您联系！'}).then(()=>{
          this.$router.push({path:'/tk/tkNeedDetail',query:{orderId:cache.orderId}})
        })
      })
    },
    getLinker(linker){//联系人修改
      this.linker=linker
    },
    openComponents(name,index,way){
      this.way=way //1 出发城市  2到达城市
      if(index!=undefined){
        this.voyageIndex=index
      }
      if(name=='date'){
        this.showDate()
      }else{
        this.$refs[name].toggle()
      }
    },
    toggle(){
      this.isShow=!this.isShow
    }
  },
  filters:{
    monDay(val){
      if(val){
        return formatDate(val).monDay
      }
      return val
    }
  }

}
</script>
<style lang="less" scoped>
@import '~Views/Tk/tkQuery/index.less';
.tkNeed{
}
.tkNeedwrapper{
    padding: 0px 6px;
    height: calc(100vh - 45px);
    overflow: hidden;
}
.font12 .van-cell{
    font-size: 12px;
}
.tag-left{
    font-size: @font-size-10;
    position: absolute;
    left: 0;
    top: 6px;
}
.tag-right{
    font-size: 18px;
    position: absolute;
    right: 4px;
    top: 62px;
}
.voyage{
    padding: 12px 30px 5px 24px;
    position: relative;
}
</style>